import { useState } from "react"
import { FormError, Modal } from "../../common"
import { useFormErrors } from "../../hooks"
import { getDateToString, getFormatNumber } from "../../../utils/convert"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"


const AnularMovimientoModal = ({ movimiento, onConfirm, onCancel }) => {

    const [observacion, setObservacion] = useState("")

    const hora = getDateToString(movimiento.fechaCobro, true).split(' ')[1] || ''
    const importe = getFormatNumber(movimiento.importeCobro, 2)

    const getErrors = () => {
        const errors = {}
        if (!observacion.trim()) errors.observacionAnulacion = VALIDATION_MESSAGE.REQUIRED
        return errors
    }

    const { errorOf, validate } = useFormErrors(getErrors)

    const onClickAnular = () => {
        if (validate()) onConfirm(observacion.trim())
    }

    return (
        <Modal
            onEscape={onCancel}
            size="lg"
            title="Anular movimiento"
            body={(
            <>
                <p>
                    {hora
                        ? `Está a punto de anular el movimiento de cobranza realizado a las ${hora} de importe $${importe}.`
                        : `Está a punto de anular el movimiento de cobranza de importe $${importe}.`
                    }
                </p>
                <div className="m-top-20">
                    <label htmlFor="observacionAnulacion" className="form-label">Escriba el motivo de la anulación para confirmar:</label>
                    <textarea
                        name="observacionAnulacion"
                        className={`form-control ${errorOf('observacionAnulacion') ? 'is-invalid' : ''}`}
                        rows={3}
                        maxLength={1000}
                        value={observacion}
                        onChange={(e) => setObservacion(e.target.value)}
                        autoFocus
                    />
                    <FormError message={errorOf('observacionAnulacion')} />
                </div>
            </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Cancelar</button>
                    <button
                        className="btn decline-button"
                        data-dismiss="modal"
                        onClick={onClickAnular}
                    >
                        Anular
                    </button>
                </div>
            )}
        />
    )
}

export default AnularMovimientoModal
